<!-- 销售退货收货历史 -->
<template>
    <div class='page_content'>
        <processAuditAction ref="processAuditAction"></processAuditAction>
        <!-- <subComponents  ref="showSelectData"></subComponents> -->
        <div class="page_content_top">
            <div class="page_content_top_line">
                <el-button type="primary" size="mini" @click="actionSet(buttonValue)"
                    v-for="(buttonValue, buttonKey) in buttonList" :key="buttonKey">
                    {{ buttonValue.jurName }}
                </el-button>
                <el-button type="primary" icon="el-icon-refresh" size="mini" @click="getDataList()">
                    刷新
                </el-button>
            </div>
            <div class="page_content_top_line">
                <el-form :inline="true" :model="getRequestData" class="demo-form-inline" v-if="pageShowData[0]" size="mini">

                    <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1"
                        v-for="(formOneValue, formOneKey) in pageShowData[0].jurconfigform" :key="formOneKey">
                        <el-select v-if="formOneValue.entityField == 'rgmState'"
                            v-model="getRequestData[formOneValue.entityField]">
                            <el-option v-for="item in $store.state.purchaseReturnState" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                        <!-- 单位 -->
                        <el-input v-else-if="formOneValue.entityField == 'cmId'" clearable v-model="getRequestData.cmName"
                            @keyup.enter.native="openSearch(formOneValue.searchId, 0, 'cmName', 'cmName,cmId')">
                            <el-button @click="openSearch(formOneValue.searchId, 0, 'cmName', 'cmName,cmId')" slot="append"
                                icon="el-icon-search"></el-button>
                        </el-input>
                        <!-- <el-input v-else-if="formOneValue.entityField =='cmId'" @focus="openSearch(formOneValue.searchId, 'cmId')" v-model="getRequestData.cmName" clearable></el-input> -->
                        <el-date-picker v-else-if="formOneValue.entityField == 'start'" size="mini"
                            v-model="getRequestData[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日"
                            value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
                        <el-date-picker v-else-if="formOneValue.entityField == 'end'" @change="changeTime" size="mini"
                            v-model="getRequestData[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日"
                            value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
                        <el-input v-else v-model.trim="getRequestData[formOneValue.entityField]"
                            :maxlength="$store.state.inputLength"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>

                </el-form>
            </div>
        </div>
        <div class="page_content_center">
            <el-table v-if="pageShowData[1]" stripe :data="returnData.list" height="100%" border style="width: 100%"
                highlight-current-row size="mini">
                <el-table-column label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <el-table-column type="expand" label="详情" width="50">
                    <template slot-scope="props">
                        <el-tabs type="border-card">
                            <!-- 辅助信息 -->
                            <el-tab-pane :label="pageShowData[2].jciName">
                                <el-table v-if="pageShowData[2]" :data="[props.row.desuRgapplySupInfo]" border
                                    style="width: 100%" size="mini">

                                    <el-table-column v-if="tableValye.isShow == 1"
                                        v-for="(tableValye, tableKey) in pageShowData[2].jurconfigtable" :key="tableKey"
                                        show-overflow-tooltip :min-width="tableValye.fieldWeight"
                                        :prop="tableValye.entityField" :label="tableValye.showField">
                                        <template slot-scope="scope">
                                            <span v-if="tableValye.fieldType == 'date'">
                                                <span v-if="scope.row[tableValye.entityField]">
                                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                                </span>
                                            </span>
                                            <span v-else-if="tableValye.isRift == 1">
                                                <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                                    scope.row[tableValye.entityField] }}</a>
                                            </span>
                                            <span v-else>
                                                {{ scope.row[tableValye.entityField] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-tab-pane>
                            <!-- 明细 -->
                            <el-tab-pane :label="pageShowData[3].jciName">
                                <el-table v-if="pageShowData[3]" :data="props.row.desuRgregoDetailVos" border
                                    style="width: 100%" size="mini">
                                    <el-table-column v-if="tableValye.isShow == 1"
                                        v-for="(tableValye, tableKey) in pageShowData[3].jurconfigtable" :key="tableKey"
                                        show-overflow-tooltip :min-width="tableValye.fieldWeight"
                                        :prop="tableValye.entityField" :label="tableValye.showField">
                                        <template slot-scope="scope">
                                            <span v-if="tableValye.fieldType == 'date'">
                                                <span v-if="scope.row[tableValye.entityField]">
                                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                                </span>
                                            </span>
                                            <span v-else-if="tableValye.isRift == 1">
                                                <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                                    scope.row[tableValye.entityField] }}</a>
                                            </span>
                                            <span v-else>
                                                {{ scope.row[tableValye.entityField] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-tab-pane>

                        </el-tabs>
                    </template>
                </el-table-column>
                <!-- 主表 -->
                <el-table-column v-if="tableValye.isShow == 1"
                    v-for="(tableValye, tableKey) in pageShowData[1].jurconfigtable" :key="tableKey" show-overflow-tooltip
                    :min-width="tableValye.fieldWeight" :prop="tableValye.entityField" :label="tableValye.showField">
                    <template slot-scope="scope">
                        <span v-if="tableValye.fieldType == 'date'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                        </span>
                        <span v-else-if="tableValye.isRift == 1">
                            <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField]
                            }}</a>
                        </span>
                        <!-- 状态判断 -->
                        <el-tag size="mini" v-else-if="tableValye.entityField == 'rgrmState'">{{
                            $common.getIsGsp(tableValye.formatterContent, scope.row.rgrmState) }}</el-tag>
                        <span v-else>
                            {{ scope.row[tableValye.entityField] }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber"
                :current-page="getRequestData.page" :page-sizes="[30, 50, 100, 500]" :page-size="30"
                layout="total, sizes, prev, pager, next, jumper" :total="returnData.total">
            </el-pagination>
        </div>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :smId="cmId" :parentSearchData="parentSearchData"
                @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: { SearchScheme },
    data() {
        //这里存放数据
        return {
            getRequestData: {
                page: 1,
                rows: 30,
                start:
                    new Date(new Date().toLocaleDateString()).getTime() -
                    31 * 24 * 3600 * 1000, //开始上一个月
                end:
                    new Date(new Date().toLocaleDateString()).getTime() +
                    24 * 60 * 60 * 1000 -
                    1, //当天最后时间
                creater: "",
                ormId: "",
                smId: "",
                cmName: '',
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            pageShowData: [],
            selectedDataIndex: 0,
            seTitle: "", //检索
            DialogVisible: false,
            seWidth: "0",
            seId: 0,
            cmId: "",
            sField: "",
            parentSearchData: {}
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.cmName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.rgamRapcus = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        //结束时间改成最后时间
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage(
                    {
                        //向窗口发送MessageEvent消息
                        cmd: "returnFormJson",
                        params: { isPenetrate }, //参数
                    },
                    "*"
                );
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        //检索带回数据
        changeInputModel(val) {
            console.log(val);

            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (val.cmId) {
                    //销售单位
                    this.cmId = val.cmId;
                    this.paramValue(val)
                }
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        getSeWidth(e) {
            // console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            // console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            // console.log(e);
            this.seTitle = e;
        },

        isShowData(name, value) {
            switch (name) {
                case "customerList":
                    var dataInfo = sessionStorage.getItem("selectCustomerData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.getRequestData.rgamRapcus = dataInfo.cmId;
                        this.getRequestData.cmName = dataInfo.cmName;
                    }

                    break;

                default:
                    this.getRequestData[name] = value;
            }
        },

        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.pageFormText({ ids: [pathId.jurId] });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 动作集合
        actionSet(actionData) {
            if (this.returnData.list.length <= 0) {
                if (!dataInfo) {
                    this.$message({
                        message: "暂无数据",
                        type: "error",
                    });
                    return false;
                }
            }
            if (!this.returnData.list[this.selectedDataIndex]) {
                this.$message({
                    message: "请先选择您要操作的数据",
                    type: "error",
                });
                return false;
            }
            var dataInfo = JSON.parse(
                JSON.stringify(this.returnData.list[this.selectedDataIndex])
            );
            switch (actionData.actionType) {
                case 4:
                    this.$refs["processAuditAction"].openBox(0, dataInfo.rgamId);
                    break;
                case 5:
                    this.$refs["processAuditAction"].openBox(1, dataInfo.rgamId);
                    break;
            }
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },
        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },
        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getSalesReceivingHistory(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        async getButtonList() {
            this.buttonList = await this.$common.getActionButton();
        },

        
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
        this.getDataList();
        this.getButtonList();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
</style>
